<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('RevokePage.title')" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="12">
        <revoke-login v-if="login" @ident="setIdent" @otp="setOTP" @email="setEmail" />
        <mail v-if="mail_otp" :otp="otp" @next="next" />
        <revoke-table v-if="table" :email="email" :certificates="certificates" :phone="phone" @ips_id="setIPS_ID"
          @type="setType" @signer="setSigner" @sent="authorizeSigner" @certificate="setCertificate" />
        <authorize v-if="authorize" :email="email" :ips_id="ips" :type="type" @authorized="revoke" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "../../i18n";
import CustomButton from "../../components/ui/input/CustomButton";
import HeaderBig from "../../components/ui/text/HeaderBig";
import RevokeLogin from "./Login";
import Authorize from "./Authorize";
import RevokeTable from "./RevokeTable";

import { log } from "@/helpers/logger";
import Mail from "./Mail";

export default {
  name: "Revoke",
  title: i18n.t("RevokePage.title"),
  components: {
    CustomButton,
    HeaderBig,
    RevokeLogin,
    RevokeTable,
    Authorize,
    Mail,
  },
  data() {
    return {
      mainColor: "",
      login: true,
      authorize: false,
      table: false,
      mail_otp: false,
      certificates: [],
      email: null,
      ips: "",
      certificate_id: "",
      otp: null,
      type: '',
      signer: null,
      certificate: '',
      phone: ''
    };
  },
  created() {
    this.mainColor = "#d2d1d1";
  },
  methods: {
    setIdent(val) {
      this.ident = val;
      this.login = false;
    },
    setCertificate(val) {
      this.certificate = val.certificate_id
    },
    setOTP(val) {
      this.otp = val;
      this.login = false;
      this.mail_otp = true;
    },
    setType(val) {
      this.type = val;
    },
    setEmail(val) {
      this.email = val;
    },
    async next() {
      await this.$store
        .dispatch("data/getCertificatesByEmail", {
          email: this.email,
        })
        .then((resp) => {
          this.phone = resp.phone;
          this.certificates = resp.certificates;
        })
        .catch((err) => {
          log("RevokePage.index.next() - " + err, "error");
        });

      this.login = false;
      this.mail_otp = false;
      this.table = true;
      this.authorize = false;
    },
    setIPS_ID(val) {
      this.ips = val;
    },
    setSigner(val) {
      this.signer = val;
    },
    authorizeSigner(val) {
      this.login = false;
      this.authorize = true;
      this.table = false;

      this.certificate_id = val.certificate_id;
    },
    revoke() {
      this.$store
        .dispatch("data/revokeCertificate", { cert_id: this.certificate_id, type: this.type })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          this.otp = "";
          log("RevokePage.index.revoke() - " + err, "error");
        });
    },
  },
};
</script>
